import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'strReplace'
})
export class StrReplacePipe implements PipeTransform {

  transform(value: any, searchStr: string, replaceStr: string): string {
    return (value || '').replaceAll(searchStr, replaceStr);
  }

}
